const ConfigAdmin = {
  classManagement: {
    classRoleSelectionList:[
      'Senior Principal',
      'Principal',
      'Vice Principal',
      'Vice Principal & EdTech Specialist',
      'Curriculum Coordinator',
      'Mandarin Curriculum Coordinator',
      'Senior Teacher',
      'Senior Mandarin Teacher',
      'Assistant Teacher 1',
      'Assistant Teacher 2',
      'Assistant Teacher 3',
      'Atelierista',
      'Visual Arts Teacher',
      'Mandarin Arts Specialist',
      'Music and Movement Specialist',
      'Physical Education Specialist',
      'Performing Arts Specialist',
      'Mandarin Performing Arts Specialist',
      'Japanese Language Specialist',
      'Hindi Language Specialist',
      'Tamil Language Specialist',
      'Malay Language Specialist',
      "English Language Specialist",
      "Class Teacher 2",
      "Class Teacher 3",
      'Other',
    ]
  },
  payment:{
    invoiceExpired:("Dear Parents/Guardians,\n\n" +
      "                    Please note that the Goods and Services Tax (GST) rate has increased from 8% to 9% on 1 January 2024.\n" +
      "                    Kindly contact the finance department at your child's school for the updated invoice.\n\n" +
      "                    Thank you.")
  },
  schoolHex:[
    {school :"M223", hex	:"4d323233", schoolID:"SCH201400000480"},
    {school :"Broadrick", hex	:"42726f61647269636b", schoolID:"SCH201300000254"},
    {school :"Newton", hex	:"4e6577746f6e", schoolID:"SCH201400000471"},
    {school :"Robertson Walk", hex :"526f62657274736f6e2057616c6b"},
    {school :"Vanda", hex	:"56616e6461", schoolID:"SCH201400000501"},
    {school :"M717", hex	:"4d373137", schoolID:""},
    {school :"Thomson", hex	:"54686f6d736f6e", schoolID:""},
    {school :"Claymore", hex	:"436c61796d6f7265", schoolID:"SCH201400000541"},
    {school :"M718", hex	:"4d373138", schoolID:""},
    {school :"215 Upper Bukit Timah", hex :"3231352042756b69742054696d6168", schoolID: "SCH201500000032"},
    {school :"Sentosa", hex	:"53656e746f7361", schoolID:"SCH201500000043"},
    {school :"Zhong Hua", hex :"5a686f6e6720487561", schoolID: "SCH201500000054"},
    {school :"Islander", hex	:"49736c616e646572", schoolID:"SCH201500000074"},
    {school :"Thomson Primary", hex :"54686f6d736f6e205072696d617279"},
    {school :"Middleton Upp Bukit Timah", hex :"4d6964646c65746f6e205570702042756b69742054696d6168"},
    {school :"SentosaPrimary", hex :"53656e746f7361205072696d617279",schoolID:"SCH201700000394"},
    {school :"Orchard", hex	:"4f726368617264", schoolID:"SCH201700000431"},
    {school :"Middleton Tampines", hex :"4d6964646c65746f6e2054616d70696e6573", schoolID: "SCH201800000510"},
    {school :"Middleton West Coast", hex :"4d6964646c65746f6e205765737420436f617374", schoolID: "SCH202300000690"},
    {school :"Gardens", hex	:"47617264656e73", schoolID:"SCH202200000680"},
  ],
  preSchool:[
    "SCH201500000074",
    "SCH202200000680",
    "SCH201400000480",
    "SCH202300000663",
    "SCH201400000471",
    "SCH201400000497",
    "SCH201500000032",
    "SCH201400000501",
    "SCH201500000054",
  ],
  misMenu:[
    "/AttendanceSubject"
  ],
  nonMisMenu:[
    "/WithdrawalList",
    "/WithdrawalManagement",
     "/WithdrawalForm"
  ],
  attendanceOptions : ['Present', 'Absent', 'Late', 'Sick', 'On Holiday', 'Sent Home'],
  misAttendanceOptions : ['Present', 'Late Arrival', 'Authorized Absence', 'Early Dismissal', 'Absent']
};

export default ConfigAdmin;